import { procurementAPI } from "../../axios";

export const actions = {
    GetAllBacActivity(context, data){
        return procurementAPI.get(`Activity/All/${data}`);
    },
    GetSingleBacActivity(context, data){
        return procurementAPI.get(`Activity/${data}`);
    },
    UpdateBacActivity(context, data){
        return procurementAPI.put(`Activity/Update/${data.id}`, data);
    },
    DeleteBacActivity(context, data){
        return procurementAPI.delete(`Activity/Delete/${data}`);
    },
    CreateBacActivity(context, data){
        return procurementAPI.post(`Activity`, data);
    },
}